import React from "react";
export var AccountDataField = function AccountDataField(_ref) {
    var name = _ref.name, value = _ref.value, notice = _ref.notice, link = _ref.link;
    return /*#__PURE__*/ React.createElement("div", {
        className: "pb-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-32 flex flex-col justify-center"
    }, name, ":"), link ? /*#__PURE__*/ React.createElement("a", {
        href: link,
        target: "_blank",
        className: "flex-1 bg-makroGreyLight px-2 py-1 ml-2 flex flex-col justify-center",
        style: {
            minHeight: "32px"
        }
    }, /*#__PURE__*/ React.createElement("span", null, value)) : /*#__PURE__*/ React.createElement("div", {
        className: "flex-1 bg-makroGreyLight px-2 py-1 ml-2 flex flex-col justify-center",
        style: {
            minHeight: "32px"
        }
    }, /*#__PURE__*/ React.createElement("span", null, value))), notice && /*#__PURE__*/ React.createElement("small", {
        className: "inline-block pl-32 ml-2"
    }, notice));
};
export default AccountDataField;
